var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',_vm._l((_vm.currentPath),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"href":item.path}},[_vm._v(_vm._s(_vm.itemTitle(item)))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b68b544","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main-components/breadcrumb-nav.vue
// module id = null
// module chunks = 